import React from 'react';
import { Link } from 'react-router-dom';
import IntlMessages from 'utils/IntlMessages';
import { useSelector } from 'react-redux';
import { translator } from '../utils/Translator';

const Error404 = () => {
  const { translate } = useSelector(({ i18n }) => i18n);

  return (
    <div className="app-wrapper page-error-container animated slideInUpTiny animation-duration-3">
      <div className="page-error-content">
        <div className="error-code mb-4 animated zoomInDown">ERROR!</div>
        <h2 className="text-center fw-regular title bounceIn animation-delay-10 animated">
          {/* <IntlMessages id="extraPages.404Msg"/> */}
          {translator(translate.ISA_Error_NoPermissionAccess, "ไม่มีสิทธิ์เข้าถึงหน้าที่ต้องการ กรุณาแจ้ง Admin เพื่อเพิ่มสิทธิ์!")}
        </h2>
        <p className="text-center zoomIn animation-delay-20 animated">
          <Link className="btn btn-primary" to="/app/dashboard"><IntlMessages id="extraPages.goHome"/></Link>
        </p>
      </div>
    </div>
  );
};

export default Error404;
